import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ReceiptPercentIcon,
  BanknotesIcon,
  ArrowsRightLeftIcon,
  TruckIcon,
} from '@heroicons/react/24/outline';

/**
 * Dashboard Quick Actions (Wave A) — the four money verbs, one tap each.
 * Each tile deep-links with an `action` param; the target page auto-opens
 * its drawer/modal and strips the param. Responsive: 2-up on phones,
 * 4-up from tablet width; tiles sized for till/kiosk touch (≥84px tall).
 */
const ACTIONS = [
  { label: 'Add Expense', icon: ReceiptPercentIcon, to: '/vendor/finance/expenses?action=add', testid: 'qa-add-expense' },
  { label: 'Record Income', icon: BanknotesIcon, to: '/vendor/finance/income?action=add', testid: 'qa-record-income' },
  { label: 'Record Settlement', icon: ArrowsRightLeftIcon, to: '/vendor/finance/aggregators?record=1', testid: 'qa-record-settlement' },
  { label: 'Pay Supplier', icon: TruckIcon, to: '/vendor/finance/payables?action=pay', testid: 'qa-pay-supplier' },
];

const QuickActions: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div
      data-testid="dashboard-quick-actions"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: 12,
        marginBottom: 20,
      }}
    >
      {ACTIONS.map(({ label, icon: Icon, to, testid }) => (
        <button
          key={label}
          type="button"
          data-testid={testid}
          onClick={() => navigate(to)}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            minHeight: 84,
            padding: '14px 10px',
            backgroundColor: 'var(--bg-surface)',
            border: '1px solid var(--border-default)',
            borderRadius: 'var(--r-lg)',
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: 600,
            color: 'var(--text-primary)',
            transition: 'background-color 120ms ease, border-color 120ms ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--bg-hover)';
            e.currentTarget.style.borderColor = 'var(--action)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--bg-surface)';
            e.currentTarget.style.borderColor = 'var(--border-default)';
          }}
          onFocus={(e) => { e.currentTarget.style.outline = '2px solid var(--focus-ring)'; e.currentTarget.style.outlineOffset = '2px'; }}
          onBlur={(e) => { e.currentTarget.style.outline = 'none'; }}
        >
          <span
            aria-hidden
            style={{
              width: 40,
              height: 40,
              borderRadius: 12,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'var(--bg-selected)',
            }}
          >
            <Icon style={{ width: 20, height: 20, color: 'var(--action)' }} />
          </span>
          {label}
        </button>
      ))}
    </div>
  );
};

export default QuickActions;
